import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=7725ba2b&scoped=true&"
import script from "./resetPassword.vue?vue&type=script&lang=js&"
export * from "./resetPassword.vue?vue&type=script&lang=js&"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=7725ba2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7725ba2b",
  null
  
)

export default component.exports